var _defs, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#484848;stroke-linecap:round;}.b{stroke-width:2px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 6.91,
    transform: "translate(10.09 7)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.025,
    transform: "translate(7 7)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 6.91,
    transform: "translate(10.09 12)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.025,
    transform: "translate(7 12)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 6.91,
    transform: "translate(10.09 17)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.025,
    transform: "translate(7 17)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.7f92f56d60be5ba4adda00e903e80a8f.svg";
export { ForwardRef as ReactComponent };